import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { CheckCircle, Mail, Clock } from 'lucide-react';

const NotificationModal = ({ show, onHide, title, message, type = 'info' }) => {
  const getIcon = () => {
    switch (type) {
      case 'success':
        return <CheckCircle size={48} className="text-success mb-3" />;
      case 'processing':
        return <Clock size={48} className="text-warning mb-3" />;
      case 'email':
        return <Mail size={48} className="text-info mb-3" />;
      default:
        return <CheckCircle size={48} className="text-primary mb-3" />;
    }
  };

  const getDefaultTitle = () => {
    switch (type) {
      case 'processing':
        return 'Transaction Processing';
      case 'email':
        return 'Email Notification';
      case 'success':
        return 'Success';
      default:
        return 'Notification';
    }
  };

  const getDefaultMessage = () => {
    switch (type) {
      case 'processing':
        return 'Kaxaa eWallet is Processing the transaction and will notify the status via Email';
      default:
        return message || 'Your request has been processed successfully.';
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="notification-modal"
      backdrop="static"
      keyboard={false}
    >
      <Modal.Body className="text-center py-4">
        <div className="d-flex flex-column align-items-center">
          {getIcon()}
          
          <h4 className="mb-3 fw-bold" style={{ color: 'var(--text-primary)' }}>
            {title || getDefaultTitle()}
          </h4>
          
          <p className="mb-4 text-center" style={{ color: 'var(--text-secondary)', fontSize: '16px', lineHeight: '1.5' }}>
            {message || getDefaultMessage()}
          </p>
          
          {type === 'processing' && (
            <div className="d-flex align-items-center gap-2 mb-4 p-3 rounded" 
                 style={{ backgroundColor: 'var(--bg-secondary)', border: '1px solid var(--border-color)' }}>
              <Mail size={20} className="text-info" />
              <small style={{ color: 'var(--text-secondary)' }}>
                You will receive an email notification once the transaction is complete
              </small>
            </div>
          )}
          
          <Button
            variant="primary"
            onClick={onHide}
            className="px-4 py-2"
            style={{
              backgroundColor: 'var(--accent-color)',
              borderColor: 'var(--accent-color)',
              minWidth: '120px'
            }}
          >
            OK
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

// Specific notification components for common use cases
export const ProcessingNotificationModal = ({ show, onHide }) => (
  <NotificationModal
    show={show}
    onHide={onHide}
    type="processing"
    title="Transaction Processing"
    message="Kaxaa eWallet is Processing the transaction and will notify the status via Email"
  />
);

export const EmailNotificationModal = ({ show, onHide, message }) => (
  <NotificationModal
    show={show}
    onHide={onHide}
    type="email"
    title="Email Notification"
    message={message || "You will receive an email notification shortly"}
  />
);

export const SuccessNotificationModal = ({ show, onHide, message }) => (
  <NotificationModal
    show={show}
    onHide={onHide}
    type="success"
    title="Success"
    message={message || "Your request has been processed successfully"}
  />
);

export default NotificationModal;